import { ref } from "valtio";

import { isInitial, PATH_DELIMITER } from "@/__main__/constants.mjs";
import featureFlags from "@/__main__/feature-flags.mjs";
import initialStateDefaults from "@/app/initial-state-defaults.mjs";
import clone from "@/util/clone.mjs";
import { CONFIG } from "@/util/state-cleanup.mjs";

// This object is a singleton which is the single source of truth for the entire state.
const initialState = initialStateDefaults;

// Recursively apply `isInitial` symbol on all objects in the initial state.
export function applyIsInitial(obj) {
  obj[isInitial] = true;
  if (!obj[isInitial]) return null;
  for (const key in obj) {
    const value = obj[key];
    if (value && typeof value === "object") {
      applyIsInitial(value);
    }
  }
  return obj;
}

// This is to prevent objects that exist in the initial state to ever be cleaned up.
export function assignInitialPaths(
  set: Set<string>,
  cursor: object = initialState,
  path: readonly PropertyKey[] = [],
) {
  for (const key in cursor) {
    const value = cursor[key];
    const currentPath = path.concat(key);

    set.add(currentPath.join(PATH_DELIMITER));

    if (!value || typeof value !== "object") continue;

    assignInitialPaths(set, value, currentPath);
  }
}

applyIsInitial(initialState);
assignInitialPaths(CONFIG.INITIAL_PATHS);

// Used to get a klean kopy of the original initial state.
export const freshInitialState = clone(initialState);

initialState.features = ref(featureFlags);

export default initialState;
